customElements.get("delivery-message") || customElements.define("delivery-message", class extends HTMLElement {
  constructor() {
    super(), this.cacheElements();
    const t = this.querySelector("[data-delivery-option-data]");
    try {
      this.data = t?.innerHTML ? JSON.parse(t.innerHTML) : null;
    } catch (t) {
      console.error("Failed to parse delivery data:", t), this.data = null;
    }
    if (this.excludedDatesSet = new Set, this.memoizedDeliveryDates = new Map, this.cutoffHour = null, 
    this.data && this.data.cutoff) {
      const t = new Date(this.data.cutoff);
      this.cutoffHour = t.getUTCHours();
    }
    this.dayNameToNumber = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6
    }, this.excludedDaysOfWeek = new Set, this.data && this.data.days_excluded && Array.isArray(this.data.days_excluded) && this.data.days_excluded.forEach((t => {
      const e = this.dayNameToNumber[t];
      void 0 !== e && this.excludedDaysOfWeek.add(e);
    })), this.monthFormatterLong = new Intl.DateTimeFormat("en-GB", {
      month: "long",
      timeZone: "UTC"
    }), this.monthFormatterShort = new Intl.DateTimeFormat("en-GB", {
      month: "short",
      timeZone: "UTC"
    });
  }
  cacheElements() {
    this.elements = Object.fromEntries(Object.entries({
      cutoffEl: "[data-delivery-cutoff-container]",
      countdownEl: "[data-delivery-countdown-container]",
      genericEl: "[data-delivery-generic-container]",
      regularContainerEl: "[data-delivery-container]",
      countdownTextEl: "[data-delivery-countdown]"
    }).map((([t, e]) => [ t, this.querySelector(e) ]))), this.elements.dateEls = this.querySelectorAll("[data-delivery-date]"), 
    this.elements.dateRangeEls = this.querySelectorAll("[data-delivery-date-range]");
  }
  formatCountdown(t, e, a) {
    return [ {
      value: t,
      label: "h"
    }, {
      value: e,
      label: "m"
    }, {
      value: a,
      label: "s"
    } ].filter((t => t.value > 0)).slice(0, 2).map((t => `${t.value}${t.label}`)).join(" and ") || "0s";
  }
  updateCountdown(t) {
    const {countdownTextEl: e} = this.elements;
    if (!e) return !1;
    const a = new Date, i = 3600 * (t - a.getUTCHours()) - 60 * a.getUTCMinutes() - a.getUTCSeconds();
    if (i < 0 || i < 60) return e.textContent = this.formatCountdown(0, 1, 0), !1;
    const s = Math.floor(i / 3600), l = Math.floor(i % 3600 / 60), n = i % 60;
    return e.textContent = this.formatCountdown(s, l, n), !0;
  }
  toggleVisibility(t, e) {
    t && (t.classList.toggle("hidden", !e), t.classList.toggle("opacity-0", !e), t.setAttribute("aria-hidden", String(!e)));
  }
  formatDateForExclusion(t) {
    return t.toISOString().split("T")[0].replace(/-/g, "/");
  }
  isDateExcluded(t) {
    const e = this.formatDateForExclusion(t), a = t.getUTCDay();
    return this.excludedDatesSet.has(e) || this.excludedDaysOfWeek.size > 0 && this.excludedDaysOfWeek.has(a);
  }
  calculateDeliveryDate(t, e, a) {
    const i = `${t}-${e.toISOString().split("T")[0]}-${e.getUTCHours()}-${a}`;
    if (this.memoizedDeliveryDates.has(i)) return new Date(this.memoizedDeliveryDates.get(i));
    const s = new Date(e);
    null !== a && e.getUTCHours() >= a && s.setUTCDate(s.getUTCDate() + 1);
    let l = 0;
    for (;l < t; ) s.setUTCDate(s.getUTCDate() + 1), this.isDateExcluded(s) || l++;
    return this.memoizedDeliveryDates.set(i, s.toISOString()), s;
  }
  formatDeliveryDate(t, e = {
    includeDay: !0,
    rangeFormat: !1,
    shortMonth: !1,
    includeMonth: !0
  }) {
    const {includeDay: a, rangeFormat: i, shortMonth: s, includeMonth: l} = e, n = t.getUTCDate(), o = s ? this.monthFormatterShort.format(t) : this.monthFormatterLong.format(t), r = t => {
      if (t > 3 && t < 21) return "th";
      switch (t % 10) {
       case 1:
        return "st";

       case 2:
        return "nd";

       case 3:
        return "rd";

       default:
        return "th";
      }
    };
    return i ? `${l ? o : ""}${l ? " " : ""}${n}${r(n)}` : `${o} ${a ? `${n}${r(n)}` : n}`;
  }
  updateElementContent(t, e) {
    t && null !== e && t.forEach((t => {
      t.textContent !== e && (t.textContent = e);
    }));
  }
  updateDisplay() {
    if (!this.data) return;
    const t = new Date, {minimum_days: e, maximum_days: a, dates_excluded: i, cutoff: s} = this.data;
    0 === this.excludedDatesSet.size && i && i.split(",").map((t => t.trim())).forEach((t => this.excludedDatesSet.add(t)));
    const l = this.cutoffHour;
    (!this.lastDateUpdate || t - this.lastDateUpdate >= 6e4) && (this.updateDeliveryDates(t, e, a, l), 
    this.lastDateUpdate = t), this.updateVisibility(t, l);
  }
  updateDeliveryDates(t, e, a, i) {
    if (this.elements.dateEls.length > 0) {
      const e = this.calculateDeliveryDate(a, t, i), s = this.formatDeliveryDate(e);
      this.updateElementContent(this.elements.dateEls, s);
    }
    if (this.elements.dateRangeEls.length > 0) {
      const s = this.calculateDeliveryDate(e, t, i), l = this.calculateDeliveryDate(a, t, i), n = s.getUTCMonth() === l.getUTCMonth() && s.getUTCFullYear() === l.getUTCFullYear();
      let o = "";
      o = n && s.getUTCDate() === l.getUTCDate() ? this.formatDeliveryDate(l, {
        includeDay: !0,
        rangeFormat: !0,
        shortMonth: !0,
        includeMonth: !0
      }) : `${this.formatDeliveryDate(s, {
        includeDay: !0,
        rangeFormat: !0,
        shortMonth: !0,
        includeMonth: !0
      })} - ${this.formatDeliveryDate(l, {
        includeDay: !0,
        rangeFormat: !0,
        shortMonth: !0,
        includeMonth: !n
      })}`, this.updateElementContent(this.elements.dateRangeEls, o);
    }
  }
  updateVisibility(t, e) {
    e && t.getUTCHours() < e ? this.elements.countdownEl ? (this.updateCountdown(e), 
    this.toggleVisibility(this.elements.cutoffEl, !1), this.toggleVisibility(this.elements.countdownEl, !0), 
    this.toggleVisibility(this.elements.genericEl, !1)) : (this.toggleVisibility(this.elements.cutoffEl, !0), 
    this.toggleVisibility(this.elements.genericEl, !1)) : (this.toggleVisibility(this.elements.genericEl, !0), 
    this.toggleVisibility(this.elements.cutoffEl, !1), this.toggleVisibility(this.elements.countdownEl, !1)), 
    this.toggleVisibility(this.elements.regularContainerEl, !0);
  }
  connectedCallback() {
    this.data && (this.data.dates_excluded && this.data.dates_excluded.split(",").map((t => t.trim())).forEach((t => this.excludedDatesSet.add(t))), 
    this.updateDisplay(), this.updateInterval = setInterval((() => {
      this.updateDisplay();
    }), 1e3));
  }
  disconnectedCallback() {
    clearInterval(this.updateInterval), this.updateInterval = null, this.excludedDatesSet.clear(), 
    this.excludedDaysOfWeek.clear(), this.data = null, this.elements = null;
  }
});